function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M15.663 6.337c.45.45.45 1.179 0 1.628l-7.698 7.698a1.151 1.151 0 11-1.628-1.628l7.698-7.698c.45-.45 1.178-.45 1.628 0z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M10 5a1 1 0 010 2c-1.448 0-3 1.552-3 3a1 1 0 01-2 0c0-2.552 2.448-5 5-5zM12 17a1 1 0 010-2c1.448 0 3-1.552 3-3a1 1 0 012 0c0 2.552-2.448 5-5 5z",
  fillRule: "nonzero"
}));

var SvgSmall = function SvgSmall(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22
    }, props), _ref)
  );
};

export default SvgSmall;